import { useEffect } from "react";
import { useLocation } from "react-router-dom";


export default function ScrollToHash() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (!hash) {
            window.scrollTo({ top: 0, behavior: "auto" });
            return;
        }
        const id = hash.slice(1);
        const t = setTimeout(() => {
            const el = document.getElementById(id);
            if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
        return () => clearTimeout(t);
    }, [pathname, hash]);
    return null;
}
